<template>
  <div class="flex justify-center items-center md:mt-24 xl:mt-32">
    <form
      class="w-full max-w-xl p-6 md:p-16 md:shadow-xl md:border dark:border-gray-700 md:rounded md:bg-white dark:bg-gray-800 transition-colors duration-200"
      @submit.prevent="recover()"
    >
      <h2 class="font-bold text-2xl text-gray-900 dark:text-gray-100 mb-10">
        Recover your password
      </h2>
      <div class="rounded-md shadow-sm md:px-2">
        <div>
          <input
            v-model="email"
            aria-label="Email address"
            name="email"
            type="email"
            required
            class="form-input"
            placeholder="Email address"
          />
        </div>
      </div>

      <div class="md:flex md:justify-center mt-6">
        <button
          type="submit"
          class="btn w-full my-1 md:w-1/2 md:mx-1"
          :disabled="!email"
        >
          Recover
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import { firebaseAuth } from "@/services/firebase";
import { sendPasswordResetEmail } from "firebase/auth";

export default {
  data() {
    return {
      email: "",
    };
  },
  methods: {
    async recover() {
      try {
        await sendPasswordResetEmail(firebaseAuth, this.email);
        this.$router.push({ name: "login" });
      } catch (error) {
        alert(error.message);
      }
    },
  },
};
</script>

<style></style>
